/**
 * One master's records.
 *
 * The page only resolves which master this is; the list fetches its own rows,
 * because search and filters change on every keystroke and a round trip per
 * character would make the screen feel like the thing it replaced.
 */

import { useParams } from "react-router-dom";

import { Crumbs, PageHead, Problem } from "@/components/kit";
import { RecordList } from "@/components/masters/RecordList";
import { displayName } from "@/lib/format";
import { loadMaster } from "@/lib/masters/load";
import { useApi } from "@/spa/useApi";

export function MasterListPage() {
  const { sport = "", master: masterCode = "" } = useParams<{ sport: string; master: string }>();
  const { data: master, loading, error } = useApi(
    () => loadMaster(sport, masterCode),
    [sport, masterCode],
    "failed to load",
  );

  if (error) {
    return (
      <Problem>
        Could not load {masterCode}: {error}
      </Problem>
    );
  }
  if (!master) return <PageHead title={masterCode} note={loading ? "Loading…" : ""} />;

  return (
    <>
      <Crumbs
        trail={[
          { label: "Sports", href: "/sports" },
          { label: displayName(sport), href: `/${sport}` },
          { label: master.label },
        ]}
      />
      <RecordList sport={sport} master={master.definition} writable={master.writable} />
    </>
  );
}
